const content = (
  <div>
    <p>
      Les Formations des Centres Médicaux sont conçues pour les
      professionnel·les de santé et les équipes médicales souhaitant renforcer
      leurs compétences, améliorer leur coordination et s’adapter aux évolutions
      du secteur. Ces formations allient expertise métier, cas pratiques et
      outils opérationnels pour répondre aux enjeux spécifiques du milieu
      médical.
    </p>
    <h2>Public concerné</h2>
    <p>
      Programmes de formation proposés aux acteurs des centres de santé, ou en
      devenir
    </p>
    <h2>Prérequis</h2>
    <p>Aucun prérequis</p>
    <h2>Méthodologie Pédagogique</h2>
    <ul>
      <li>
        Utilisation de supports visuels, fiches pratiques, extraits de films
      </li>
      <li>Exposés théoriques interactifs</li>
      <li>Discussions de groupe et partages d’expériences</li>
      <li>Exercices pratiques et études de cas</li>
      <li>Ateliers en binômes et en petits groupes</li>
      <li>Plans d’actions élaborés</li>
    </ul>
    <h2>Formules</h2>
    <ul>
      <li>Formation au choix ou demande de formation sur mesure</li>
      <li>Parcours Mentorat par thème</li>
      <li>Coachings individuels ou en groupe</li>
    </ul>
    <h2>Durée et modalité d’organisation</h2>
    <p>Formation de 1 à 3 jours chacune pouvant être décomposée en ateliers</p>
    <p>
      Nos formations comprennent les cours, tour de table, exercices, cas
      pratiques, plan d’actions
    </p>
    <h2>Modalités pratiques</h2>
    <p>En présentiel, distanciel , mixte ou hybride</p>
    <p>Nos formations sont à priori, prises en charge à 100% par les OPCO</p>
    <h2>Programme de la formation</h2>
    <h3>
      Formation accueil du public et des personnes en situation d’handicap
    </h3>
    <p>
      <b>HÔTESSES D'ACCUEIL ET SECRÉTAIRES MÉDICALES</b>
    </p>
    <p>
      <b>Objectifs</b> : Assurer un accueil de qualité, optimiser la gestion des
      rendez-vous et améliorer la communication avec les patients
    </p>
    <p>Formation proposée (2 jours)</p>
    <ul>
      <li>
        <b>Techniques d'accueil et relation patient</b> : savoir rassurer, gérer
        les urgences et les attentes
      </li>
      <li>
        <b>Techniques argumentaires</b> : comment transformer un appel en
        rendez-vous pris
      </li>
      <li>
        <b>Gestion des conflits et communication non violente</b> : répondre aux
        plaintes et aux patients stressés, gestion des patients difficiles
      </li>
      <li>
        <b>Maîtrise des outils de gestion des RDV et logiciels médicaux</b>
      </li>
    </ul>
    <h3>Formation posture et gestion des patients</h3>
    <p>
      <b>PRATICIENS</b>
    </p>
    <p>
      <b>Obiectifs</b> : Améliorer leur posture managériale, la gestion des
      patients et leur capacité à fidéliser
    </p>
    <p>Formation proposée (2 jours)</p>
    <ul>
      <li>
        <b>Communication avec le patient</b> : pédagogie et réassurance
      </li>
      <li>
        <b>Gestion du stress et des émotions face aux patients anxieux</b>
      </li>
      <li>
        <b>Leadership et cohésion d'équipe</b>
      </li>
      <li>
        <b>Utilisation de l'intelligence collective</b>
      </li>
      <li>
        <b>Techniques argumentaires pour l'acceptation des soins et devis</b>
      </li>
      <li>
        <b>
          Gestion des conflits et communication bienveillante avec les patients
          et le personnel
        </b>
      </li>
    </ul>

    <h3>FORMATION EN GESTION</h3>
    <p>
      <b>PERSONNEL ADMINISTRATIF ET GESTIONNAIRE</b>
    </p>
    <p>
      Objectifs : Optimiser la gestion quotidienne, structurer les stocks et
      fluidifier l'organisation interne
    </p>
    <p>Formation proposée (2 jours) :</p>
    <ul>
      <li>
        <b>
          Gestion des stocks et des commandes (matériel, consommables,
          médicaments)
        </b>
      </li>
      <li>
        <b>Organisation et optimisation des plannings du personnel</b>
      </li>
      <li>
        <b>
          Mise en place de processus pour une meilleure gestion administrative
        </b>
      </li>
      <li>
        <b>Relation avec les mutuelles et gestion des dossiers patients</b>
      </li>
      <li>
        <b>Argumenteretpersuadersesinterlocuteurs</b>
      </li>
    </ul>

    <h3>Formation cohesion d’equipe et motivation</h3>
    <p>
      <b>TOUS LES ACTEURS DU CENTRE / GROUPE</b>
    </p>
    <p>
      Objectifs : Favoriser un bon climat de travail et améliorer la
      collaboration
    </p>
    <p>Formation proposée (2 jours) :</p>
    <ul>
      <li>
        <b>Développer la cohésion d'équipe dans un centre dentaire</b>
      </li>
      <li>
        <b>Motivation et engagement des collaborateurs</b>
      </li>
      <li>
        <b>Pratiquer l’intelligence collective</b>
      </li>
      <li>
        <b>Leadership pour les responsables de centre</b>
      </li>
      <li>
        <b>Gestion des tensions et des conflits entre collaborateurs</b>
      </li>
    </ul>

    <h3>FORMATION DEVELOPPER SES COMPETENCES MANAGERIALES</h3>
    <p>
      <b>GESTIONNAIRES & DIRECTEURS DE CENTRES / GROUPE</b>
    </p>
    <p>Objectifs : Comprendre son rôle de Manager et structurer son équipe</p>
    <p>Formation proposée (2 jours) :</p>
    <ul>
      <li>
        <b>Affirmer son leadership</b>
      </li>
      <li>
        <b>Communiquer avec impact</b>
      </li>
      <li>
        <b>Mobiliser et motiver son équipe</b>
      </li>
      <li>
        <b>Savoir prendre du recul</b>
      </li>
      <li>
        <b>Optimiser l’intelligence collective</b>
      </li>
      <li>
        <b>Gestion des émotions</b>
      </li>
      <li>
        <b>Gestion des conflits</b>
      </li>
    </ul>

    <h3>Les fondamentaux du management</h3>
    <p>
      <b>MANAGERS & DIRECTEURS DE CENTRES</b>
    </p>
    <p>
      Objectifs : Gérer les priorités, développer les compétences de chaque
      membre de l’équipe dans un environnement harmonieux et serein
    </p>
    <p>Formation proposée (2 jours)</p>
    <ul>
      <li>
        <b>Comprendre le fonctionnement d’un groupe de travail</b>
      </li>
      <li>
        <b>Gestion du temps & bilan du temps</b>
      </li>
      <li>
        <b>Organiser le travail collectif</b>
      </li>
      <li>
        <b>Planifier les activités de son équipe par priorité</b>
      </li>
      <li>
        <b>Piloter et suivre l’activité de son équipe</b>
      </li>
      <li>
        <b>Évaluer l’impact du changement sur l’organisation de l’activité</b>
      </li>
      <li>
        <b>Calibrer sa communication managériale</b>
      </li>
      <li>
        <b>
          Organiser les relations de l’équipe au quotidien : gérer les tensions
        </b>
      </li>
    </ul>
    <h3>FORMATION MANAGERS DE PROXIMITE</h3>
    <p>
      <b>GESTIONNAIRE & MANAGERS DE CENTRES / GROUPE</b>
    </p>
    <p>
      Objectifs : Assurer quotidiennement l’encadrement et l’accompagnement de
      ses équipes
    </p>
    <p>Formation proposée (2/3 jours) :</p>
    <ul>
      <li>
        <b>Les rôles et les missions du manager de proximité</b>
      </li>
      <li>
        <b>Le pouvoir du manager de proximité et la notion du leadership</b>
      </li>
      <li>
        <b>Les comportements efficaces : le management situationnel</b>
      </li>
      <li>
        <b>Développerl’autonomiedes collaborateurs</b>
      </li>
      <li>
        <b>Reconnaîtrelesréussitespour encourager</b>
      </li>
      <li>
        <b>Gérer les situations difficiles</b>
      </li>
    </ul>

    <h3>FORMATION COMPTABILITE & GESTION</h3>
    <p>
      <b>LES DIRECTEURS ET LES GESTIONNAIRES DE CENTRE</b>
    </p>
    <p>
      Objectifs : Comprendre et maîtriser les bases de la comptabilité et de la
      gestion appliquées aux centres dentaires
    </p>
    <p>Formation proposée (2 jours) :</p>
    <ul>
      <li>
        <b>Les fondamentaux de la comptabilité et de la gestion</b> (les
        spécificités comptables, les charges et produits, amortissements et
        provisions, présentation du bilan et du comptes de résultat)
      </li>
      <li>
        <b>Gestion des coûts et rentabilité</b> (gestion de la trésorerie et
        prévisions financières)
      </li>
      <li>
        <b>Gestion administrative conforme aux réglementations</b>
      </li>
    </ul>

    <h3>FORMATION MANAGEMENT, RESSOUCES HUMAINES, ET DEMARCHE QUALITE</h3>
    <p>
      <b>LES DIRECTEURS ET LES GESTIONNAIRES DE CENTRE</b>
    </p>
    <p>
      Objectifs : Développer des compétences en management, leadership et
      gestion des ressources humaines pour assurer un environnement de travail
    </p>
    <p>Formation proposée (2 jours) :</p>
    <ul>
      <li>
        <b>Adopter une gestion efficace et adaptée au secteur de la santé</b>
      </li>
      <li>
        <b>Optimiser le recrutement et l'intégration des collaborateur</b>s
      </li>
      <li>
        <b>Améliorer la communication interne et la cohésion d'équipe</b>
      </li>
      <li>
        <b>Gérer efficacement les plannings et l'organisation du travail</b>
      </li>
      <li>
        <b>Piloter les performances et fidéliser les talents</b>
      </li>
      <li>
        <b>Développer la démarche qualité</b>
      </li>
    </ul>
  </div>
);

export default content;
